import { render, staticRenderFns } from "./ConnectionMemoModal.vue?vue&type=template&id=31795e96"
import script from "./ConnectionMemoModal.vue?vue&type=script&lang=js"
export * from "./ConnectionMemoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports